import { checkDefined } from 'faro-common-model';
/**
 * @return the built FeatureFlag
 */
export function toFeatureFlag(feature) {
    checkDefined(feature.id, 'Feature', 'id');
    checkDefined(feature.enabled, 'Feature', 'enabled');
    return {
        id: feature.id,
        enabled: feature.enabled,
    };
}
//# sourceMappingURL=feature-flag.js.map